import { effects } from 'redux-saga'

import { RECEIVE_CREDENTIALS } from 'internal-components/src/redux/modules/authentication'
import { FINISH_LOADING } from 'internal-components/src/redux/modules/meta'
import { RECEIVE_ERROR } from 'internal-components/src/redux/modules/loading'
import makeAddressAutocomplete from 'internal-components/src/redux/sagas/autocomplete/address'
import makeUserAutocomplete from 'internal-components/src/redux/sagas/autocomplete/user'
import autocomplete from 'internal-components/src/redux/sagas/autocomplete'
import authentication from 'internal-components/src/redux/sagas/authentication'
import client from 'internal-components/src/redux/sagas/client'
import invoice from 'internal-components/src/redux/sagas/invoice'
import partner from 'internal-components/src/redux/sagas/partner'
import product from 'internal-components/src/redux/sagas/product'
import service from 'internal-components/src/redux/sagas/service'
import signup from 'internal-components/src/redux/sagas/signup'

import loadAuthenticatedData from './loadAuthenticatedData'
import loadRequirements from './loadRequirements'
import loginOn403 from './signup/loginOn403'
import signupEdit from './signupEdit'

export default function createRootSaga(apis, sagaOptions) {
  return function* rootSaga() {
    const addressAutocomplete = makeAddressAutocomplete({
      raven: sagaOptions.raven,
      search: sagaOptions.addressSearch,
    })
    const userAutocomplete = makeUserAutocomplete({
      invocation: apis.invocation,
    })

    yield [
      effects.call(authentication, apis, sagaOptions),
      effects.call(autocomplete, sagaOptions.autocompleteDelay, {
        address: addressAutocomplete,
        user: userAutocomplete,
      }),
      effects.call(client, apis),
      effects.call(invoice, apis),
      effects.takeEvery(RECEIVE_CREDENTIALS, loadAuthenticatedData),
      effects.takeEvery(FINISH_LOADING, loadRequirements),
      effects.takeEvery(RECEIVE_ERROR, loginOn403, sagaOptions.getHref),
      effects.call(partner, apis),
      effects.call(product, apis),
      effects.call(service, apis),
      effects.call(signup, apis),
      effects.call(signupEdit, apis, sagaOptions),
    ]
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/index.js